import { PageTitle, PageTitleContainer } from "@/ui-components/utils/menu-items/page-title";
import PipelineEditor from "../pipeline-editor";

const CreatePipeline = () => {
  return (
    <div>
      <PageTitleContainer>
        <div className="flex flex-row justify-between items-center">
          <PageTitle>Neue Pipeline erstellen</PageTitle>
        </div>
      </PageTitleContainer>
      <div className="p-4 w-1/2 items-center m-auto">
        <PipelineEditor />
      </div>
    </div>
  );
};

export default CreatePipeline;
